/**
 * @see https://chir.ag/projects/name-that-color/#3B7BBF
 */
export const colorNames = {
  graySolid: '#808080', // rgb(128, 128, 128)
  tropicalBlue: '#D1DAFA', // rgb(209, 218, 250)
  azureRadiance: '#007fff', // rgb(0, 127, 255)
  toreaBay: '#1034A6', // rgb(16, 52, 166)
  studioPurple: '#7851A9', // rgb(120, 81, 169)
  flirt: '#A2006D', // rgb(162, 0, 109)
  bahamaBlue: '#005A92', // rgb(0, 90, 146)
  frenchLilac: '#D5BCEB', // rgb(213, 188, 235)
  lilacBush: '#a87bd6', // rgb(168, 123, 214)
  pinkSalmon: '#FF91A4', // rgb(255, 145, 164)
  azalea: '#f4c1d1', // rgb(244, 193, 209)
  jadeGreen: '#00AB66', // rgb(0, 171, 102)
  midnightBlue: '#002D72', // rgb(0, 45, 114)
  portage: '#84a6f0', // rgb(132, 166, 240)
  carrotOrange: '#ED9121', // rgb(237, 145, 33)
  blazeOrange: '#FF5E0E', // rgb(255, 94, 14)
  pizazz: '#FF8C00', // rgb(255, 140, 0)
  greenHaze: '#009E60', // rgb(0, 158, 96)
  harlequin: '#39FF14', // rgb(57, 255, 20)
  navyBlue: '#000080', // rgb(0, 0, 128)
  red: '#FF0000', // rgb(255, 0, 0)
}
